import type { LabeledGraphicSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { outlineNegative } from 'components/Editor/styled/Outline'
import type { ElementStyleCss } from 'services/Branding/types'

const PointTooltipStyled = styled.div<{ $styles?: ElementStyleCss<LabeledGraphicSchemaType> }>`
  ${outlineNegative}
`

export default PointTooltipStyled
